import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { useI18n } from "@/lib/i18n";

const FAQS_NL = [
  ["Wat is 'onderzoekskwaliteit'?", "Onderzoekskwaliteit betekent dat onze peptiden uitsluitend bedoeld zijn voor in-vitro onderzoek in een gecontroleerde laboratoriumsetting. Elk product wordt gevalideerd via HPLC en third-party geanalyseerd."],
  ["Zijn deze producten geschikt voor menselijke consumptie?", "Nee. Onze producten zijn uitsluitend bedoeld voor onderzoeksdoeleinden en zijn niet geschikt voor consumptie door mens of dier. Zie onze onderzoeksdisclaimer."],
  ["Hoe wordt verzonden?", "Discreet en getrackt via PostNL/DHL. Bestellingen voor 15:00 worden binnen 24 uur verzonden. NL binnen 1-2 dagen, EU 2-5 dagen."],
  ["Welke betaalmethoden accepteren jullie?", "Creditcard (Visa, Mastercard, Amex), iDEAL, PayPal, Klarna, SEPA-overschrijving en Bunq — allemaal via Stripe."],
  ["Kan ik een Certificate of Analysis krijgen?", "Ja. Elke batch heeft een third-party analyse rapport beschikbaar op verzoek. Neem contact op met vermelding van je lotnummer."],
  ["Wat is jullie retourbeleid?", "Vanwege de aard van steriele farmaceutische onderzoeksmaterialen kunnen geopende flacons niet worden geretourneerd. Beschadigde zendingen worden binnen 7 dagen vervangen."],
];

const FAQS_EN = [
  ["What does 'research grade' mean?", "Research grade means our peptides are exclusively intended for in-vitro research in a controlled laboratory setting. Every product is validated via HPLC and third-party analyzed."],
  ["Are these products safe for human consumption?", "No. Our products are strictly intended for research purposes and are not fit for human or animal consumption. See our research disclaimer."],
  ["How do you ship?", "Discreetly and tracked via PostNL/DHL. Orders before 3PM ship within 24h. NL 1-2 days, EU 2-5 days."],
  ["Which payment methods do you accept?", "Credit card (Visa, Mastercard, Amex), iDEAL, PayPal, Klarna, SEPA bank transfer and Bunq — all via Stripe."],
  ["Can I get a Certificate of Analysis?", "Yes. Each batch has a third-party analysis report available on request. Contact us referencing your lot number."],
  ["What is your return policy?", "Due to the nature of sterile pharmaceutical research materials, opened vials cannot be returned. Damaged shipments will be replaced within 7 days."],
];

export default function FAQ() {
  const { t, lang } = useI18n();
  const faqs = lang === "nl" ? FAQS_NL : FAQS_EN;
  return (
    <div data-testid="faq-page" className="pt-32 pb-24 bg-[#F7F7F6] min-h-screen">
      <div className="max-w-[1200px] mx-auto px-6 md:px-12 grid md:grid-cols-12 gap-8">
        <div className="md:col-span-4">
          <p className="font-mono-label text-[11px] text-neutral-500 mb-8">[ QUESTIONS ]</p>
          <h1 className="font-serif-display font-light text-5xl md:text-6xl leading-[0.98] sticky top-32">
            {t("faq_title")}
          </h1>
        </div>
        <div className="md:col-span-8">
          <Accordion type="single" collapsible className="border-t border-neutral-300">
            {faqs.map(([q, a], i) => (
              <AccordionItem key={i} value={`item-${i}`} className="border-b border-neutral-300">
                <AccordionTrigger data-testid={`faq-q-${i}`} className="font-serif-display text-2xl md:text-3xl py-8 text-left hover:no-underline">
                  <span className="flex gap-6 items-baseline">
                    <span className="font-mono-label text-[10px] text-neutral-500">0{i + 1}</span>
                    {q}
                  </span>
                </AccordionTrigger>
                <AccordionContent className="text-neutral-600 pb-8 pl-10 max-w-xl leading-relaxed text-base">
                  {a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </div>
  );
}
